// Action Items Service
// Manages action items extracted from emails with filtering, grouping, and status tracking

import { supabase, handleSupabaseError } from '@/lib/supabase';

// ============================================
// TEMPORARY MOCK DATA FOR UI/UX TESTING
// TODO: Remove after UI validation complete
// ============================================
const USE_MOCK_DATA = true; // TODO: Set to false after UI testing

const TEST_USER_ID = '8de40a06-01f3-4c14-a733-501d64420a47';

const MOCK_ACTION_ITEMS = [
  {
    id: 'action-1',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-2',
    camp_program_id: null,
    action_type: 'payment',
    title: 'Pay $190 balance',
    description: 'Final payment for Summer Soccer Academy registration',
    due_date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    due_time: null,
    amount: 190.00,
    form_name: null,
    url: null,
    status: 'pending',
    priority: 'high',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-2',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-1',
    camp_program_id: null,
    action_type: 'payment',
    title: 'Pay $190 deposit',
    description: 'Initial deposit for Summer Soccer Academy',
    due_date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    due_time: null,
    amount: 190.00,
    form_name: null,
    url: null,
    status: 'completed',
    priority: 'high',
    auto_calculated_priority: true,
    completed_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    dismissed_at: null,
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-3',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-8',
    camp_program_id: null,
    action_type: 'form',
    title: 'Submit Medical Form',
    description: 'Upload completed medical form and emergency contacts to parent portal',
    due_date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    due_time: null,
    amount: null,
    form_name: 'Medical & Emergency Contact Form',
    url: null,
    status: 'pending',
    priority: 'medium',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-4',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-5',
    camp_program_id: null,
    action_type: 'registration',
    title: 'Register for early bird discount',
    description: 'Complete registration by Dec 15 to save $50',
    due_date: '2025-12-15',
    due_time: null,
    amount: 400.00,
    form_name: null,
    url: null,
    status: 'pending',
    priority: 'medium',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-5',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-10',
    camp_program_id: null,
    action_type: 'registration',
    title: 'Complete camp registration',
    description: 'Only 3 spots remaining - register before Dec 18',
    due_date: '2025-12-18',
    due_time: null,
    amount: 350.00,
    form_name: null,
    url: null,
    status: 'pending',
    priority: 'high',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-6',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-3',
    camp_program_id: null,
    action_type: 'preparation',
    title: 'Prepare camp equipment',
    description: 'Purchase cleats (no metal), shin guards, and label all items',
    due_date: '2026-06-14',
    due_time: null,
    amount: null,
    form_name: null,
    url: null,
    status: 'pending',
    priority: 'low',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-7',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-9',
    camp_program_id: null,
    action_type: 'deadline',
    title: 'Review parent portal',
    description: 'Check portal for camp updates and required forms',
    due_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    due_time: null,
    amount: null,
    form_name: null,
    url: null,
    status: 'overdue',
    priority: 'high',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: null,
    created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'action-8',
    user_id: '8de40a06-01f3-4c14-a733-501d64420a47',
    email_id: 'email-11',
    camp_program_id: null,
    action_type: 'deadline',
    title: 'Review camp schedule',
    description: 'Note drop-off and pick-up locations',
    due_date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    due_time: null,
    amount: null,
    form_name: null,
    url: null,
    status: 'dismissed',
    priority: 'low',
    auto_calculated_priority: true,
    completed_at: null,
    dismissed_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
  }
];

/**
 * Action Items Service Class
 * Handles action item operations including filtering, grouping, dashboard views, and status updates
 */
class ActionItemsService {
  /**
   * Get all action items for user with filtering and sorting
   * @param {string} userId - User ID
   * @param {Object} filters - Optional filters
   * @param {string} filters.status - Filter by status (pending, completed, dismissed, overdue)
   * @param {string} filters.priority - Filter by priority (high, medium, low)
   * @param {string} filters.actionType - Filter by action_type
   * @param {Object|Date} filters.dueDate - Filter by due_date (date range or single date)
   * @param {string} filters.campProgramId - Filter by camp_program_id
   * @param {string} filters.emailId - Filter by email_id
   * @param {Object} sort - Sort options
   * @param {string} sort.by - Sort field (due_date, priority, created_at)
   * @param {string} sort.order - Sort order (asc, desc)
   * @returns {Promise<Array>} Array of action items
   */
  async getActionItems(userId, filters = {}, sort = {}) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      // TEMPORARY: Return mock data for UI testing
      if (USE_MOCK_DATA && userId === TEST_USER_ID) {
        let filteredItems = MOCK_ACTION_ITEMS.filter(item => item.user_id === userId);

        // Apply filters
        if (filters.status) {
          filteredItems = filteredItems.filter(item => item.status === filters.status);
        }
        if (filters.priority) {
          filteredItems = filteredItems.filter(item => item.priority === filters.priority);
        }
        if (filters.actionType) {
          filteredItems = filteredItems.filter(item => item.action_type === filters.actionType);
        }
        if (filters.dueDate) {
          if (filters.dueDate instanceof Date) {
            const dateStr = filters.dueDate.toISOString().split('T')[0];
            filteredItems = filteredItems.filter(item => item.due_date === dateStr);
          } else if (filters.dueDate.start || filters.dueDate.end) {
            if (filters.dueDate.start) {
              const startDate = filters.dueDate.start instanceof Date
                ? filters.dueDate.start.toISOString().split('T')[0]
                : filters.dueDate.start;
              filteredItems = filteredItems.filter(item => item.due_date >= startDate);
            }
            if (filters.dueDate.end) {
              const endDate = filters.dueDate.end instanceof Date
                ? filters.dueDate.end.toISOString().split('T')[0]
                : filters.dueDate.end;
              filteredItems = filteredItems.filter(item => item.due_date <= endDate);
            }
          }
        }
        if (filters.campProgramId) {
          filteredItems = filteredItems.filter(item => item.camp_program_id === filters.campProgramId);
        }
        if (filters.emailId) {
          filteredItems = filteredItems.filter(item => item.email_id === filters.emailId);
        }

        // Apply sorting
        const sortBy = sort.by || 'due_date';
        const sortOrder = sort.order || 'asc';

        if (sortBy === 'due_date' && !sort.order) {
          filteredItems.sort((a, b) => {
            if (a.due_date && !b.due_date) return -1;
            if (!a.due_date && b.due_date) return 1;
            if (a.due_date && b.due_date) {
              const dateCompare = new Date(a.due_date) - new Date(b.due_date);
              if (dateCompare !== 0) return dateCompare;
            }
            const priorityOrder = { high: 1, medium: 2, low: 3 };
            return (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
          });
        } else {
          filteredItems.sort((a, b) => {
            const aVal = a[sortBy];
            const bVal = b[sortBy];
            if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
            if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
            return 0;
          });
        }

        return filteredItems;
      }

      console.log('✅ ActionItemsService: getActionItems called for userId:', userId, 'filters:', filters);

      // Build base query
      let query = supabase
        .from('email_action_items')
        .select('*')
        .eq('user_id', userId);

      // Apply filters
      if (filters.status) {
        const validStatuses = ['pending', 'completed', 'dismissed', 'overdue'];
        if (!validStatuses.includes(filters.status)) {
          throw new Error(`Invalid status: ${filters.status}. Must be one of: ${validStatuses.join(', ')}`);
        }
        query = query.eq('status', filters.status);
      }

      if (filters.priority) {
        const validPriorities = ['high', 'medium', 'low'];
        if (!validPriorities.includes(filters.priority)) {
          throw new Error(`Invalid priority: ${filters.priority}. Must be one of: ${validPriorities.join(', ')}`);
        }
        query = query.eq('priority', filters.priority);
      }

      if (filters.actionType) {
        const validActionTypes = ['payment', 'form', 'registration', 'deadline', 'preparation'];
        if (!validActionTypes.includes(filters.actionType)) {
          throw new Error(`Invalid action type: ${filters.actionType}. Must be one of: ${validActionTypes.join(', ')}`);
        }
        query = query.eq('action_type', filters.actionType);
      }

      if (filters.dueDate) {
        if (filters.dueDate instanceof Date) {
          // Single date - get items due on this date
          const dateStr = filters.dueDate.toISOString().split('T')[0];
          query = query.eq('due_date', dateStr);
        } else if (filters.dueDate.start || filters.dueDate.end) {
          // Date range
          if (filters.dueDate.start) {
            const startDate = filters.dueDate.start instanceof Date
              ? filters.dueDate.start.toISOString().split('T')[0]
              : filters.dueDate.start;
            query = query.gte('due_date', startDate);
          }
          if (filters.dueDate.end) {
            const endDate = filters.dueDate.end instanceof Date
              ? filters.dueDate.end.toISOString().split('T')[0]
              : filters.dueDate.end;
            query = query.lte('due_date', endDate);
          }
        }
      }

      if (filters.campProgramId) {
        query = query.eq('camp_program_id', filters.campProgramId);
      }

      if (filters.emailId) {
        query = query.eq('email_id', filters.emailId);
      }

      // Apply sorting
      const sortBy = sort.by || 'due_date';
      const sortOrder = sort.order || 'asc';

      // Default sort: due_date ASC, then priority DESC (high first)
      if (sortBy === 'due_date' && !sort.order) {
        query = query.order('due_date', { ascending: true, nullsLast: true });
        // Secondary sort by priority
        // Note: Supabase doesn't support multiple orderBy directly, so we'll sort in JavaScript if needed
      } else {
        query = query.order(sortBy, { 
          ascending: sortOrder === 'asc',
          nullsLast: sortBy === 'due_date'
        });
      }

      const { data, error } = await query;

      if (error) {
        throw handleSupabaseError(error);
      }

      let actionItems = data || [];

      // Apply secondary sort if default sorting is used
      if (sortBy === 'due_date' && !sort.order) {
        actionItems = actionItems.sort((a, b) => {
          // First by due_date (nulls last)
          if (a.due_date && !b.due_date) return -1;
          if (!a.due_date && b.due_date) return 1;
          if (a.due_date && b.due_date) {
            const dateCompare = new Date(a.due_date) - new Date(b.due_date);
            if (dateCompare !== 0) return dateCompare;
          }
          // Then by priority (high, medium, low)
          const priorityOrder = { high: 1, medium: 2, low: 3 };
          return (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
        });
      }

      console.log('✅ ActionItemsService: Returning', actionItems.length, 'action items');
      return actionItems;
    } catch (error) {
      console.error('Error getting action items:', error);
      throw error;
    }
  }

  /**
   * Get action items grouped by status
   * @param {string} userId - User ID
   * @returns {Promise<Object>} Action items grouped by status
   */
  async getActionItemsByStatus(userId) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      // TEMPORARY: Return mock data for UI testing
      if (USE_MOCK_DATA && userId === TEST_USER_ID) {
        const actionItems = await this.getActionItems(userId);
        const grouped = {
          pending: [],
          overdue: [],
          completed: [],
          dismissed: []
        };

        actionItems.forEach(item => {
          if (grouped[item.status]) {
            grouped[item.status].push(item);
          }
        });

        // Sort each group
        Object.keys(grouped).forEach(status => {
          grouped[status].sort((a, b) => {
            const priorityOrder = { high: 1, medium: 2, low: 3 };
            const priorityDiff = (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
            if (priorityDiff !== 0) return priorityDiff;

            if (a.due_date && !b.due_date) return -1;
            if (!a.due_date && b.due_date) return 1;
            if (a.due_date && b.due_date) {
              return new Date(a.due_date) - new Date(b.due_date);
            }

            return new Date(a.created_at) - new Date(b.created_at);
          });
        });

        return grouped;
      }

      console.log('📊 ActionItemsService: getActionItemsByStatus called for userId:', userId);

      // Get all action items for user
      const actionItems = await this.getActionItems(userId);

      // Group by status
      const grouped = {
        pending: [],
        overdue: [],
        completed: [],
        dismissed: []
      };

      actionItems.forEach(item => {
        if (grouped[item.status]) {
          grouped[item.status].push(item);
        }
      });

      // Sort each group by priority and due date
      Object.keys(grouped).forEach(status => {
        grouped[status].sort((a, b) => {
          // First by priority
          const priorityOrder = { high: 1, medium: 2, low: 3 };
          const priorityDiff = (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
          if (priorityDiff !== 0) return priorityDiff;

          // Then by due_date (nulls last)
          if (a.due_date && !b.due_date) return -1;
          if (!a.due_date && b.due_date) return 1;
          if (a.due_date && b.due_date) {
            return new Date(a.due_date) - new Date(b.due_date);
          }

          // Finally by created_at
          return new Date(a.created_at) - new Date(b.created_at);
        });
      });

      console.log('📊 ActionItemsService: Grouped by status:', {
        pending: grouped.pending.length,
        overdue: grouped.overdue.length,
        completed: grouped.completed.length,
        dismissed: grouped.dismissed.length
      });

      return grouped;
    } catch (error) {
      console.error('Error getting action items by status:', error);
      throw error;
    }
  }

  /**
   * Get action items for dashboard (urgent + due soon)
   * @param {string} userId - User ID
   * @param {number} daysAhead - Number of days ahead to look (default: 7)
   * @returns {Promise<Array>} Action items due within next N days, sorted by priority
   */
  async getDashboardActionItems(userId, daysAhead = 7) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      // TEMPORARY: Return mock data for UI testing
      if (USE_MOCK_DATA && userId === TEST_USER_ID) {
        const cutoffDate = new Date();
        cutoffDate.setDate(cutoffDate.getDate() + daysAhead);
        const cutoffDateStr = cutoffDate.toISOString().split('T')[0];

        let actionItems = MOCK_ACTION_ITEMS.filter(item => 
          item.user_id === userId && 
          item.status === 'pending' &&
          (item.due_date === null || item.due_date <= cutoffDateStr)
        );

        // Sort by priority then due_date
        actionItems.sort((a, b) => {
          const priorityOrder = { high: 1, medium: 2, low: 3 };
          const priorityDiff = (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
          if (priorityDiff !== 0) return priorityDiff;

          if (a.due_date && !b.due_date) return -1;
          if (!a.due_date && b.due_date) return 1;
          if (a.due_date && b.due_date) {
            return new Date(a.due_date) - new Date(b.due_date);
          }

          return new Date(a.created_at) - new Date(b.created_at);
        });

        // Limit to top 20
        actionItems = actionItems.slice(0, 20);

        // Add email data (mock)
        actionItems = actionItems.map(item => ({
          ...item,
          user_camp_emails: item.email_id ? { id: item.email_id } : null
        }));

        return actionItems;
      }

      console.log('📋 ActionItemsService: getDashboardActionItems called for userId:', userId, 'daysAhead:', daysAhead);

      // Calculate cutoff date
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() + daysAhead);
      const cutoffDateStr = cutoffDate.toISOString().split('T')[0];

      // Query action items
      // Fetch action items first, then get email data separately if needed
      let query = supabase
        .from('email_action_items')
        .select('*')
        .eq('user_id', userId)
        .eq('status', 'pending')
        .or(`due_date.is.null,due_date.lte.${cutoffDateStr}`);

      const { data, error } = await query;

      if (error) {
        throw handleSupabaseError(error);
      }

      let actionItems = data || [];

      // Fetch camp email data for each action item if email_id exists
      if (actionItems.length > 0) {
        const emailIds = actionItems
          .map(item => item.email_id)
          .filter(id => id !== null && id !== undefined);
        
        if (emailIds.length > 0) {
          const { data: emailData } = await supabase
            .from('user_camp_emails')
            .select('id, camp_name, camp_organization')
            .in('id', emailIds);

          // Create a map of email data by id
          const emailMap = {};
          if (emailData) {
            emailData.forEach(email => {
              emailMap[email.id] = email;
            });
          }

          // Attach email data to action items
          actionItems = actionItems.map(item => ({
            ...item,
            user_camp_emails: item.email_id ? emailMap[item.email_id] : null
          }));
        }
      }

      // Sort by priority (high, medium, low), then by due_date (earliest first, nulls last)
      actionItems = actionItems.sort((a, b) => {
        // First by priority
        const priorityOrder = { high: 1, medium: 2, low: 3 };
        const priorityDiff = (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99);
        if (priorityDiff !== 0) return priorityDiff;

        // Then by due_date (nulls last)
        if (a.due_date && !b.due_date) return -1;
        if (!a.due_date && b.due_date) return 1;
        if (a.due_date && b.due_date) {
          return new Date(a.due_date) - new Date(b.due_date);
        }

        // Finally by created_at
        return new Date(a.created_at) - new Date(b.created_at);
      });

      // Limit to top 20 for dashboard
      actionItems = actionItems.slice(0, 20);

      console.log('📋 ActionItemsService: Returning', actionItems.length, 'dashboard action items');
      return actionItems;
    } catch (error) {
      console.error('Error getting dashboard action items:', error);
      throw error;
    }
  }

  /**
   * Update action item status
   * @param {string} itemId - Action item ID
   * @param {Object} updates - Update options
   * @param {string} updates.status - New status
   * @param {Date|string} updates.completedAt - Completion timestamp (optional)
   * @returns {Promise<boolean>} Success status
   */
  async updateActionItem(itemId, updates = {}) {
    try {
      if (!itemId) {
        throw new Error('Action item ID is required');
      }

      console.log('✏️ ActionItemsService: updateActionItem called for itemId:', itemId, 'updates:', updates);

      // Validate status if provided
      if (updates.status) {
        const validStatuses = ['pending', 'completed', 'dismissed', 'overdue'];
        if (!validStatuses.includes(updates.status)) {
          throw new Error(`Invalid status: ${updates.status}. Must be one of: ${validStatuses.join(', ')}`);
        }
      }

      // Get current item to check previous status
      const { data: currentItem, error: fetchError } = await supabase
        .from('email_action_items')
        .select('status, completed_at')
        .eq('id', itemId)
        .single();

      if (fetchError) {
        throw handleSupabaseError(fetchError);
      }

      if (!currentItem) {
        throw new Error('Action item not found');
      }

      const updateData = {
        updated_at: new Date().toISOString()
      };

      // Update status
      if (updates.status !== undefined) {
        updateData.status = updates.status;

        // Handle completed_at timestamp
        if (updates.status === 'completed') {
          updateData.completed_at = updates.completedAt
            ? (updates.completedAt instanceof Date ? updates.completedAt.toISOString() : updates.completedAt)
            : new Date().toISOString();
        } else if (currentItem.status === 'completed' && updates.status !== 'completed') {
          // Clearing completed_at if status changes from completed to something else
          updateData.completed_at = null;
        }
      }

      const { error } = await supabase
        .from('email_action_items')
        .update(updateData)
        .eq('id', itemId);

      if (error) {
        throw handleSupabaseError(error);
      }

      console.log('✏️ ActionItemsService: Action item updated successfully');
      return true;
    } catch (error) {
      console.error('Error updating action item:', error);
      throw error;
    }
  }

  /**
   * Dismiss action item
   * @param {string} itemId - Action item ID
   * @returns {Promise<boolean>} Success status
   */
  async dismissActionItem(itemId) {
    try {
      if (!itemId) {
        throw new Error('Action item ID is required');
      }

      console.log('🚫 ActionItemsService: dismissActionItem called for itemId:', itemId);

      const updateData = {
        status: 'dismissed',
        dismissed_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      const { error } = await supabase
        .from('email_action_items')
        .update(updateData)
        .eq('id', itemId);

      if (error) {
        throw handleSupabaseError(error);
      }

      console.log('🚫 ActionItemsService: Action item dismissed successfully');
      return true;
    } catch (error) {
      console.error('Error dismissing action item:', error);
      throw error;
    }
  }

  /**
   * Create manual action item
   * @param {string} userId - User ID
   * @param {Object} actionItemData - Action item data
   * @param {string} actionItemData.action_type - Action type (required)
   * @param {string} actionItemData.title - Title (required)
   * @param {string} actionItemData.description - Description (optional)
   * @param {Date|string} actionItemData.due_date - Due date (optional)
   * @param {string} actionItemData.due_time - Due time (optional)
   * @param {number} actionItemData.amount - Amount (optional)
   * @param {string} actionItemData.form_name - Form name (optional)
   * @param {string} actionItemData.url - URL (optional)
   * @param {string} actionItemData.priority - Priority (optional, defaults to medium)
   * @param {string} actionItemData.camp_program_id - Camp program ID (optional)
   * @param {string} actionItemData.email_id - Email ID (optional)
   * @returns {Promise<Object>} Created action item
   */
  async createActionItem(userId, actionItemData) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      if (!actionItemData.action_type) {
        throw new Error('action_type is required');
      }

      if (!actionItemData.title) {
        throw new Error('title is required');
      }

      console.log('➕ ActionItemsService: createActionItem called for userId:', userId, 'data:', actionItemData);

      // Validate action_type
      const validActionTypes = ['payment', 'form', 'registration', 'deadline', 'preparation'];
      if (!validActionTypes.includes(actionItemData.action_type)) {
        throw new Error(`Invalid action_type: ${actionItemData.action_type}. Must be one of: ${validActionTypes.join(', ')}`);
      }

      // Validate priority if provided
      let priority = actionItemData.priority || 'medium';
      const validPriorities = ['high', 'medium', 'low'];
      if (!validPriorities.includes(priority)) {
        console.warn(`Invalid priority: ${priority}. Defaulting to medium.`);
        priority = 'medium';
      }

      // Determine if priority was explicitly set
      const autoCalculatedPriority = !actionItemData.priority;

      // Prepare insert data
      const insertData = {
        user_id: userId,
        action_type: actionItemData.action_type,
        title: actionItemData.title,
        description: actionItemData.description || null,
        due_date: actionItemData.due_date
          ? (actionItemData.due_date instanceof Date
              ? actionItemData.due_date.toISOString().split('T')[0]
              : actionItemData.due_date)
          : null,
        due_time: actionItemData.due_time || null,
        amount: actionItemData.amount || null,
        form_name: actionItemData.form_name || null,
        url: actionItemData.url || null,
        priority: priority,
        auto_calculated_priority: autoCalculatedPriority,
        camp_program_id: actionItemData.camp_program_id || null,
        email_id: actionItemData.email_id || null,
        status: 'pending'
      };

      const { data, error } = await supabase
        .from('email_action_items')
        .insert(insertData)
        .select()
        .single();

      if (error) {
        throw handleSupabaseError(error);
      }

      console.log('➕ ActionItemsService: Action item created successfully:', data.id);
      return data;
    } catch (error) {
      console.error('Error creating action item:', error);
      throw error;
    }
  }

  /**
   * Calculate overdue items and update statuses (should run daily via cron)
   * @returns {Promise<number>} Count of updated items
   */
  async updateOverdueItems() {
    try {
      console.log('⏰ ActionItemsService: updateOverdueItems called');

      // Try using the database function first
      try {
        const { data, error } = await supabase
          .rpc('update_overdue_action_items');

        if (!error && data !== null && data !== undefined) {
          console.log('⏰ ActionItemsService: Updated', data, 'overdue items using database function');
          return data;
        }
      } catch (funcError) {
        console.log('Database function not available, using manual query:', funcError.message);
      }

      // Fallback to manual query
      const today = new Date().toISOString().split('T')[0];

      // Get all pending items with due_date < today
      const { data: overdueItems, error: fetchError } = await supabase
        .from('email_action_items')
        .select('id')
        .eq('status', 'pending')
        .not('due_date', 'is', null)
        .lt('due_date', today);

      if (fetchError) {
        throw handleSupabaseError(fetchError);
      }

      if (!overdueItems || overdueItems.length === 0) {
        console.log('⏰ ActionItemsService: No overdue items found');
        return 0;
      }

      // Batch update status to overdue
      const itemIds = overdueItems.map(item => item.id);
      const { error: updateError } = await supabase
        .from('email_action_items')
        .update({
          status: 'overdue',
          updated_at: new Date().toISOString()
        })
        .in('id', itemIds);

      if (updateError) {
        throw handleSupabaseError(updateError);
      }

      const updatedCount = itemIds.length;
      console.log('⏰ ActionItemsService: Updated', updatedCount, 'overdue items');
      return updatedCount;
    } catch (error) {
      console.error('Error updating overdue items:', error);
      throw error;
    }
  }
}

// Create singleton instance
const actionItemsService = new ActionItemsService();

// Export individual functions for convenience
export const getActionItems = (userId, filters, sort) =>
  actionItemsService.getActionItems(userId, filters, sort);

export const getActionItemsByStatus = (userId) =>
  actionItemsService.getActionItemsByStatus(userId);

export const getDashboardActionItems = (userId, daysAhead) =>
  actionItemsService.getDashboardActionItems(userId, daysAhead);

export const updateActionItem = (itemId, updates) =>
  actionItemsService.updateActionItem(itemId, updates);

export const dismissActionItem = (itemId) =>
  actionItemsService.dismissActionItem(itemId);

export const createActionItem = (userId, actionItemData) =>
  actionItemsService.createActionItem(userId, actionItemData);

export const updateOverdueItems = () =>
  actionItemsService.updateOverdueItems();

export default actionItemsService;
